import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import { CDN_LINK } from "@globalConfig";
import stl from "./SingleOrderComponent.module.css";
var SingleOrderComponent = function SingleOrderComponent(_ref) {
  var link = _ref.link,
    image = _ref.image,
    title = _ref.title,
    color = _ref.color,
    status = _ref.status,
    date = _ref.date,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? null : _ref$tag;
  return /*#__PURE__*/React.createElement(Link, {
    to: link,
    className: stl.tamweelOrderContainer
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: "".concat(title, " image")
  })), /*#__PURE__*/React.createElement("div", null, tag && /*#__PURE__*/React.createElement("span", {
    className: stl.tag,
    style: {
      backgroundColor: tag.color
    }
  }, tag.txt), /*#__PURE__*/React.createElement("strong", null, title), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: stl.status,
    style: {
      color: color
    }
  }, status), /*#__PURE__*/React.createElement("span", {
    className: stl.date
  }, date.day, ", ", date.date)), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/Arrow_Left.svg",
    alt: "arr"
  }))));
};
export default SingleOrderComponent;